import React from 'react';

const Skill = () => {
    return (
        <div className="my-5 container-fluid ">
            <h2 className="text-uppercase text-warning text-center mb-4">My Technical Skills</h2>
            <div className="container w-75 mb-5">
                <div className="row gy-4 gx-5">
                    <div className="col-md-6">
                        <h4>HTML5 90%</h4>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ "width": "90%" }}>90%</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h4>CSS3 80%</h4>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ "width": "80%" }}>80%</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h4>JavaScript 60%</h4>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ "width": "70%" }}>70%</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h4>React.JS 50%</h4>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ "width": "60%" }}>60%</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h4>Node.JS 35%</h4>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ "width": "35%" }}>35%</div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h4>Express.JS 25%</h4>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ "width": "25%" }}>25%</div>
                        </div>
                    </div>
                </div>
            </div>
            <hr style={{ color: "white", width: "800px", margin: "0 auto" }} />
        </div>
    );
};

export default Skill;